// src/utils/axiosMain.js
import axios from "axios";
import { Navigate, json } from "react-router-dom";
import { toast } from "react-toastify";
import { showLoader, hideLoader } from "./utils/loaderController";
import { DataProvider, getSetIsLoggingOut } from "./context/DataProvider";

const baseURL = "https://tendersearchai.tendertiger.co.in/api";

// Create an axios instance
let localstoretoken = localStorage.getItem("logDetails");
const axiosMain = axios.create({
  // timeout: 10000, // Set a timeout for requests
  headers: {
    "Content-Type": "application/json",
    ...(localstoretoken !== null && {
      Authorization: `Bearer ${JSON.parse(localstoretoken).Token}`,
    }),
    // Add other default headers here if needed
  },
});
async function fetchIPAddress() {
  try {
    const response = await axios.get("https://api.ipify.org?format=json");
    return response.data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
    return "::1"; // Default IP if fetching fails
  }
}
// Add a request interceptor
axiosMain.interceptors.request.use(
  async (config) => {
    showLoader();
    const ipAddress = await fetchIPAddress();
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (["post", "put", "patch"].includes(config.method?.toLowerCase())) {
      config.data = {
        ...config.data, // Preserve existing body data

        Hosturl: window.location.origin + "/",
        DomainUrl: window.location.origin + "/",
        WebDomainUrl: window.location.origin + "/",
        SourceUrl: window.location.origin + "/",

        // Hosturl: "https://beta.tendergpt.io",
        // DomainUrl: "https://beta.tendergpt.io",
        // WebDomainUrl: "https://beta.tendergpt.io",
        // SourceUrl: "https://beta.tendergpt.io",

        // Hosturl: "https://tendergpt.io/",
        // DomainUrl: "https://tendergpt.io/",
        // WebDomainUrl: "https://tendergpt.io/",
        // SourceUrl: "https://tendergpt.io/",

        IPAddress: ipAddress,
      };
    }
    // You can modify the request config before the request is sent
    // For example, add an authorization token if available

    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosMain.interceptors.response.use(

  (response) => {
    // Any status code that lies within the range of 2xx cause this function to trigger
    // Do something with response data
    hideLoader();
    return response;
  },
  (error) => {
    hideLoader();
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response && error.response.status === 401) {
      // Handle unauthorized errors
      // For example, you can redirect to login page
      //  
      // window.location.href = "/";
      toast.error("Token is Expire Please login again!.");

      localStorage.removeItem("logDetails");
      localStorage.removeItem("token");
      const setIsLoggingOut = getSetIsLoggingOut();
      if (setIsLoggingOut) setIsLoggingOut(false);
    }
    return Promise.reject(error);
  }
);

export default axiosMain;
